/** @format */

export const capitalize = (s: string): string => {
  if (!s) return s;
  const [first, ...rest] = Array.from(s); // итерирует по code point'ам
  return first.toUpperCase() + rest.join('');
};

export const snakeToCamel = (value: string): string => {
  return value.replace(/_([a-z])/g, (_, letter) => {
    return letter.toUpperCase();
  });
};

export const toStr = (v: unknown): string => String(v ?? '');

/**
 * Очистит строку от символов, не являющихся цифрами
 * @param value
 */

export const removeNonDigits = (value: string): string => {
  return value.replace(/\D+/g, '');
};
